import Link from 'next/link';
import { useRouter } from 'next/router';
import { QrCode } from 'lucide-react';
import { useBasePath } from '../../../../lib/use-base-path';
import { markNavFromDrawer } from '../../../../lib/drawer-nav';
import { useLeaveChatOnNavigate } from '../../../../lib/use-leave-chat';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import { useTranslation } from '../../../../lib/i18n';
import { useProfileLinkEntry } from '../../profile-links/use-profile-link-entry';
import drawerStyles from '../mobile/MobileSidebar.module.css';
import styles from './CommunityLink.module.css';

/**
 * "My profile link" — the account menu's entry into Profile links (design mock entry 3): in the wide rail's
 * foot and the phone drawer's floor, beside the account card, as both phones' drawers carry it. Same two
 * skins as `CommunityLink` (its geometry is shared), but an IN-APP destination, so a next/link with the mount
 * prefix. Hidden outside `specs.SymphonyProfileLinks`.
 */
export function ProfileLinkMenuLink({ variant, collapsed = false }: { variant: 'rail' | 'drawer'; collapsed?: boolean }) {
  const { t } = useTranslation();
  const router = useRouter();
  const basePath = useBasePath();
  const leaveChat = useLeaveChatOnNavigate();
  const { logPageClickBi } = useGenericBi();
  const entry = useProfileLinkEntry();
  if (!entry.enabled) return null;
  const label = t('profileLinks.menu.myLink');
  const current = router.pathname.startsWith('/profile-links');
  const common = {
    href: '/profile-links',
    as: `${basePath}/profile-links`,
    'aria-current': current ? ('page' as const) : undefined,
    onClick: () => {
      logPageClickBi({ page_name: 'menu', button_name: 'profile_links', origin: 'menu' });
      markNavFromDrawer();
      leaveChat();
    },
  };

  if (variant === 'drawer') {
    return (
      <Link {...common} className={drawerStyles.row}>
        <span aria-hidden className={drawerStyles.rowIcon}>
          <QrCode size={20} />
        </span>
        <span className={drawerStyles.rowLabel}>{label}</span>
      </Link>
    );
  }
  return (
    <Link {...common} title={collapsed ? label : undefined} className={`orion-nav-item ${styles.railRow}${collapsed ? ` ${styles.railRowCollapsed}` : ''}`}>
      <span aria-hidden className={`orion-nav-icon ${styles.railIcon}`}>
        <QrCode size={16} />
      </span>
      {!collapsed && <span className="orion-rail-label">{label}</span>}
    </Link>
  );
}
